/* prettier-ignore */

import { Component, computed, effect, inject, input, InputSignal, signal, ViewEncapsulation } from '@angular/core';
import { RequestService } from './service/request.service';
import { tap } from 'rxjs';
import { ChatStyles } from './interface/chatStyles.interface';
import { DataChatService } from './service/dataChat.service';
// import { PoiSidebarComponent } from './components/poiSidebar/poiSidebar.component';
import { StatisticsService } from '../app/services/statistics.service';
import { WebSocketService } from './service/webSocket.service';
import { DebugService } from '../app/services/debug.service';
import { ToolsService } from '../app/services/tools.service';
import { ScrollService } from './service/scrollContainer.service';
import { ChatViewComponent } from './chatView/chatView.component';
import { CssStylesService } from './service/cssStyles.service';
import { v4 as uuidv4 } from 'uuid';
import { RestService } from 'src/app/services';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-chatbot',
  imports: [
    ChatViewComponent, 
    TranslateModule
    // PoiSidebarComponent
  ],
  standalone: true,
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class NewChatBotComponent {
  private rest = inject(RestService);
  private statistics = inject(StatisticsService)
  private webSocketService = inject(WebSocketService);
  private debugService = inject(DebugService);
  private cssService = inject(CssStylesService);

  public requestService = inject(RequestService);
  public toolsService = inject(ToolsService)
  public dataChat = inject(DataChatService);
  public scrollService = inject(ScrollService);

  private token?: string;

  //SE ESTABLECE EL CHAT A MOSTRAR
  public chatID: InputSignal<string> = input.required<string>();

  ngAfterViewInit() {
    this.startChatBot();
  }

  startChatBot() {
    if (!this.chatID())
      return;

    this.dataChat.id.set(this.chatID());
    this.token = this.statistics.sessionId;
    this.debugService.info(this.token, '[ChatBotComponent] TOKENCHAT');
    this.dataChat.token.set(this.token);

    // this.webSocketService.connectAll();
    this.webSocketService.connectAll();
    if (this.dataChat.messages()?.length > 1)
      return;

    this.getChatConfig();
  }

  getChatConfig() {
    this.requestService.getChatDataStyles().subscribe((res) => {
      this.debugService.debug(res, '[ChatBotComponent] ChatBot Styles API Response');

      const data: ChatStyles = res.data;
      this.cssService.setCSSVariables(data);

      const initialMessage = this.getInitialMessage(data);
      this.dataChat.initialMessage.set(initialMessage);

      const recommendedMessages = this.getRecommendedMessages(data);
      this.dataChat.recommendedMessages.set(recommendedMessages);

      this.getChatHistoryFromApi();
    });
  };

  getChatHistoryFromApi(){
    this.requestService.getHistory().subscribe(res => {
      const data = JSON.parse(res?.conversations);
      if (data?.length === 0)
        return;

      this.dataChat.hasHistory.set(true);
      this.debugService.debug(data, '[CHAT HISTORY]');
      data?.entries?.forEach(e => {
        if (e.message_id)
          return;

        this.dataChat.messages.update((prev) => [
          ...prev,
          {
            id: e.completion_id ?? uuidv4(),
            role: e.is_chatbot ? 'assistant' : 'user',
            content: e.content,
            show: true,
          },
        ]);
      });
      this.scrollService.scrollToBottom();
    })
  }

  getRecommendedMessages(data: ChatStyles) {
    let recommendedMessages: any = data.new_recommended_messages;
    if (Object.values(recommendedMessages)?.some((msg: any) => msg.length))
      return recommendedMessages;

    const oldrecommendedMessages: any = data.recommended_messages ?? [];
    if (!oldrecommendedMessages?.length)
      return [];

    return this.rest.device?.languages?.reduce((acc, lang) => {
      acc[lang] = oldrecommendedMessages;
      return acc;
    }, {});
  }

  getInitialMessage(data: ChatStyles) {
    let initialMessage = data.new_initial_messages;
    if (initialMessage)
      return initialMessage;

    const oldInitialMessage = data.initial_messages?.[0]
    if (!oldInitialMessage)
      return null;

    return this.rest.device?.languages?.reduce((acc, lang) => {
      acc[lang] = oldInitialMessage;
      return acc;
    }, {});
  }

}